/**
 * Holds information about a medication.
 */

export class Medication {
  /**
   * The medication's unique identifier.
   */
  id: string;

  /**
   * The medication's name.
   */
  name: string;

  /**
   * The different ways the medication can be administered.
   * e.g. oral, IV, etc.
   */
  routes: string[];

  /**
   * Whether this is a controlled substance or not
   */
  controlledSubstance: boolean;

  /**
   * whether this medication is administered on a sliding scale (e.g., insulin)
   */
  slidingScale: boolean;

  /**
   * whether this medication is administered at meal times
   */
  mealTimes: boolean;

  constructor(id?: string, name?: string, routes?: string[], controlledSubstance?: boolean,
    slidingScale?: boolean, mealTimes?: boolean
  ) {
    this.id = id ?? '';
    this.name = name ?? '';
    this.routes = routes ?? [];
    this.controlledSubstance = controlledSubstance ?? false;
    this.slidingScale = slidingScale ?? false;
    this.mealTimes = mealTimes ?? false;
  }

  /**
   * @returns The medication's ID.
   */
  getId(): string {
    return this.id;
  }

  /**
   * @returns The medication's name.
   */
  getName(): string {
    return this.name;
  }

  /**
   * @returns The medications routes as a list.
   */
  getRoutes(): string[] {
    return this.routes;
  }

  getControlledSubstance(): boolean {
    return this.controlledSubstance;
  }

  /**
   * @returns The medication's routes as a string, with the routes separated by commas.
   */
  getRoutesAsCSV(): string {
    return this.routes.join(', ');
  }
}
